import { Outlet } from "react-router";
import { Link } from "@/lib/router";
import { BrandMark } from "@/components/brand-mark";

// 로그인·가입 공통 레이아웃. 상단 로고를 누르면 랜딩 페이지로 돌아간다.
export default function AuthLayout() {
  return (
    <div className="flex flex-1 flex-col">
      <header className="px-6 py-5">
        <Link href="/" className="text-lg">
          <BrandMark />
        </Link>
      </header>
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
}
